import React from 'react'
import FashoCenter from '../../assets/Images/fashoCenter.svg'
import { Link } from 'react-router-dom';

const SectionOne = () => {
    return (
        <>
        <div className="mx-auto bg-gray-900  px-4 xl:px-0 py-10 xl:py-20 text-white ">
                    <div className="flex flex-col-reverse lg:flex-row flex-wrap items-center justify-center">
                        <div className="lg:w-1/2 w-full">
                            <h1 className="text-6xl w-1/2 xl:w-full xl:text-7xl font-mono font-black">Generate Outfits Instantly.</h1>
                            <div className=" text-xl lg:text-3xl pt-5 xl:pt-20">
                                <h2>The next big thing starts here.</h2>
                                <h2>Use Fasho To Generate All Your</h2>
                                <h2>Clothing Items From Your Very Own Wardrobe! </h2>
                            </div>
                            <Link to="/tutorial">
                                <button className="text-xl w-full xl:text-3xl xl:w-9/12 mt-4 xl:mt-11 py-6 bg-linear-button-home text-white ">Let's Generate</button>
                            </Link>
                        </div>
                        <div className="lg:w-2/5 w-full ">
                            <img className="w-full" src={FashoCenter} />
                        </div>
                    </div>
                </div>
    </>
    )
}

export default SectionOne